var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketSet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_20X20_photo_Back",
    "data-name": "20X20 photo Back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4536",
    "data-name": "Rectangle 4536",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_345",
    "data-name": "Mask Group 345",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.667 -0.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21425",
    "data-name": "Path 21425",
    d: "M18.447,3.333H15.78a2.18,2.18,0,0,0-1.213.367l-1.2.813L12.453,3.8a2.187,2.187,0,0,0-1.333-.467H2.887a2.22,2.22,0,0,0-2.22,2.22V15.78A2.22,2.22,0,0,0,2.887,18h8.22a2.22,2.22,0,0,0,1.333-.467l.907-.713,1.213.813A2.18,2.18,0,0,0,15.773,18H18.44a2.22,2.22,0,0,0,2.227-2.22V5.553a2.22,2.22,0,0,0-2.22-2.22Zm-5.113,8A.667.667,0,1,1,14,10.667.667.667,0,0,1,13.333,11.333ZM14,13.8a.667.667,0,1,1-.667-.667A.667.667,0,0,1,14,13.8Zm-.667-5.6A.667.667,0,1,1,14,7.533.667.667,0,0,1,13.333,8.2Z",
    fill: "#404040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSet);
export default __webpack_public_path__ + "static/media/ticket_set.ca285a33a8878f9e3614f7aa497e15c9.svg";
export { ForwardRef as ReactComponent };